import styled from 'styled-components';

const defaultGlassBlur = 50;

export const Wrapper = styled.div`
  display: flex;
  position: fixed;
  z-index: 100;
  backdrop-filter: blur(${defaultGlassBlur}px);
  -webkit-backdrop-filter: blur(${defaultGlassBlur}px);
  overflow-y: auto;

  width: 100vw;
  height: 100%;
`;
